import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { AmiDatePicker as DatePicker } from './DatePicker';

const FormDatePicker = ({
  id,
  label,
  className,
  labelClassName,
  selected,
  onChange,
  filterDate,
  showTimeSelect,
  ...rest
}) => {
  return (
    <FormGroup className={className}>
      {label && label !== '' && (
        <Label for={id} className={'form-label ' + labelClassName}>
          {label}
        </Label>
      )}
      <DatePicker
        selected={selected}
        onChange={onChange}
        filterDate={filterDate}
        showTimeSelect={showTimeSelect}
        {...rest}
      />
    </FormGroup>
  );
};

FormDatePicker.propTypes = {
  id: PropTypes.node,
  label: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.any,
  onChange: PropTypes.func,
  filterDate: PropTypes.func,
  showTimeSelect: PropTypes.bool
};

export { FormDatePicker };
